<template>
  <v-text-field
    v-if="emitValue"
    :outlined="!disabled"
    :filled="disabled"
    v-model="value"
    :hide-details="'auto'"
    type="number"
    :disabled="disabled"
    :label="label"
    :hint="hint"
    :min="params.min"
    :max="params.max"
    @input="emitValue"
  >
    <template v-if="$slots.required" v-slot:prepend-inner>
      <slot name="required"></slot>
    </template>
  </v-text-field>

<!-- Componenet for IE problems wit even @input -->
  <v-text-field
    v-else
    :outlined="!disabled"
    :filled="disabled"
    v-model="value"
    :hide-details="'auto'"
    type="number"
    :disabled="disabled"
    :label="label"
    :hint="hint"
    :min="params.min"
    :max="params.max"
    @input="emitValue"
  >
    <template v-if="$slots.required" v-slot:prepend-inner>
      <slot name="required"></slot>
    </template>
  </v-text-field>
</template>

<script>
export default {
  props: {
    label: String,
    hint: String,
    placeholder: String,
    disabled: Boolean,
    initialValue: {
      required: false,
    },
    inputData: Object,
    rules: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data: ({ initialValue }) => ({
    value: initialValue,
    isInternetExplorer: (navigator.userAgent.indexOf('Trident/') > -1),
  }),
  created() {
    if (this.initialValue != null) {
      this.$emit('update:inputData', {
        value: this.initialValue,
      });
    }
    this.throttle = this.$throttle((value) => {
      this.$emit('update:inputData', { value });
    }, 200);
  },
  methods: {
    emitValue(value) {
      this.throttle(value);
    },
  },
  beforeDestroy() {
    this.$emit('update:inputData', {});
  },
};
</script>
